<template>
  <div>
    <div class="ml-4 mt-4">
      <icon-view
        :has-border="false"
        icon-color="#fff"
        icon-background="#ff7058"
        icon="fas fa-info"
        :title="title"
        variant="custom-icon-view"
      />
    </div>
    <div class="row d-flex justify-item-between pl-2 ml-0 pb-1">
      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <div class="container-label">
          <span class="label-design">{{ contactNameLabel }}:</span>
        </div>
        <ValidationProvider
          v-slot="{ errors }"
          name="name"
          :rules="isFieldRequired ? 'required' : ''"
        >
          <custom-input2
            id="txtName"
            :class="disabled ? 'custom-input-edit' : 'custom-input-read'"
            v-model="value.name"
            :error="errors[0]"
            :custom-error-msg="`El ${contactNameLabel} es requerido.`"
            :disabled="disabled && !canEditRegisteredPersonalData"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <validation-provider
          v-slot="{ errors }"
          :rules="isFieldRequired ? 'required' : ''"
        >
          <custom-input2
            v-model="value.lastName"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            label="Primer Apellido:"
            maxlength="50"
            :disabled="disabled && !canEditRegisteredPersonalData"
          />
        </validation-provider>
      </div>
      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <custom-input2
          v-model="value.secondLastName"
          label="Segundo Apellido:"
          maxlength="50"
          :disabled="disabled && !canEditRegisteredPersonalData"
        />
      </div>

      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <div class="container-label">
          <span class="label-design">{{ contactOcupationLabel }}:</span>
        </div>
        <ValidationProvider
          v-slot="{ errors }"
          name="ocupation"
          :rules="isFieldRequired ? 'required' : ''"
        >
          <CustomInput2
            id="txtOccupation"
            :class="disabled ? 'custom-input-edit' : 'custom-input-read'"
            v-model="value.occupation"
            :error="errors[0]"
            :custom-error-msg="`La ${contactOcupationLabel} es requerida.`"
            :disabled="disabled && !canEditRegisteredPersonalData"
          />
        </ValidationProvider>
      </div>

      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <validation-provider
          v-slot="{ errors }"
          :custom-messages="{
            email: 'El campo debe ser un correo electrónico válido.',
            required: 'El campo es requerido',
          }"
          :rules="{
            required: isFieldRequired ? true : false,
            email: true,
          }"
        >
          <custom-input2
            v-model="value.email"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            label="Correo Electrónico:"
            maxlength="250"
            :disabled="disabled && !canEditRegisteredPersonalData"
          />
        </validation-provider>
      </div>
      <div class="col-md-4 col-sm-12 mt-3 pt-0">
        <div class="container-label">
          <span class="label-design">{{ contactPhoneLabel }}:</span>
        </div>
        <ValidationProvider
          v-slot="{ errors }"
          :custom-messages="{
            completePhone: 'Se deben completar los números telefónicos.',
            required: `El ${contactPhoneLabel} es requerido.`,
          }"
          name="PhoneNumber"
          :rules="isFieldRequired ? 'required|completePhone' : ''"
        >
          <CustomInput2
            id="txtPhoneNumber"
            :class="disabled ? 'custom-input-edit' : 'custom-input-read'"
            v-model="value.phoneNumber"
            mask-type="Phone"
            placeholder="xxx-xxx-xxxx"
            :error="errors[0]"
            :disabled="disabled && !canEditRegisteredPersonalData"
          />
        </ValidationProvider>
      </div>
    </div>

    <div class="mb-1 ml-3">
      <ValidationProvider
        v-slot="{ errors }"
        mode="eager"
        :rules="
          isFieldRequired && !canEditRegisteredPersonalData ? 'required' : ''
        "
      >
        <WizardQuestion
          id="qPreQuestionsA"
          :ref="'RefCreateAccountPortal'"
          v-model="value.createAccountPortal"
          description="¿Desea crear una cuenta en el Portal de Padres?"
          :answer-control-type="1"
          :has-icon="false"
          :force-error="errors[0] != null"
          :hide-icon-box="true"
          error-message="mensaje"
          class="custom-wizard-question"
          :is-disabled="disabled || canEditRegisteredPersonalData"
        />
        <Error
          v-if="errors[0]"
          variant="no-border error-margin-left error-custom"
          message="El campo es requerido."
        />
      </ValidationProvider>
    </div>

    <custom-checkbox
      class="mt-4 ml-4"
      text="Marcar como Contacto Primario"
      v-model="value.isPrincipal"
      :disabled="isMarkedAsPrimaryDisabled || canEditRegisteredPersonalData"
      @input="$emit('refreshContactPerson')"
    />

    <custom-error
      v-if="
        validate &&
          !disabled &&
          !isMarkedAsPrimaryDisabled &&
          !value.isPrincipal
      "
      message="El campo es requerido"
      variant="no-border"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomInput from '@/components/common/CustomInput';
import CustomInput2 from 'CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import WizardQuestion from '@/components/pei/WizardQuestion';
import Error from '@/components/common/Error';

import IconView from 'icon-view';
import CustomCheckbox from 'CheckBox';
import CustomRadio from 'custom-radio';
import CustomError from 'custom-error';

export default {
  name: 'BasicVueComponent',
  components: {
    ValidationProvider,
    CustomInput,
    CustomInput2,
    ValidationObserver,
    CustomDropDown,
    WizardQuestion,
    Error,
    IconView,
    CustomCheckbox,
    CustomRadio,
    CustomError,
  },
  props: {
    title: { type: String, required: true, default: 'titulo' },
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canEditRegisteredPersonalData: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Boolean,
      default: false,
    },
    contactNameLabel: {
      type: String,
      default: 'Nombre del contacto',
    },
    contactOcupationLabel: {
      type: String,
      default: 'Cargo del contacto',
    },
    contactPhoneLabel: {
      type: String,
      default: 'Teléfono del contacto',
    },
    isMarkedAsPrimaryDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isCustodianRequired: {
      type: Boolean,
      required: true,
    },
    hasNullFields: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {},
  computed: {
    hasFormNullFields() {
      let result = false;
      if (
        this.value.name == '' ||
        this.value.lastName == '' ||
        this.value.occupation == '' ||
        this.value.email == '' ||
        this.value.phoneNumber == '' ||
        this.value.name == null ||
        this.value.lastName == null ||
        this.value.occupation == null ||
        this.value.email == null ||
        this.value.phoneNumber == null
      ) {
        result = true;
      }
      return result;
    },
    hasAnyFieldFilled() {
      let hasFieldFilled = false;

      // Verificar si algún campo del custodiano está lleno y no nulo
      if (
        this.value.name ||
        this.value.lastName ||
        this.value.secondLastName ||
        this.value.email ||
        this.value.phone
      ) {
        hasFieldFilled = true;
      }

      return hasFieldFilled;
    },
    isFieldRequired() {
      return (
        this.value.isPrincipal == true ||
        this.isCustodianRequired ||
        this.hasAnyFieldFilled
      );
    },
  },
};
</script>

<style scoped lang="scss">
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.custom-wizard-question {
  background: transparent;
  margin-left: 15px;
  margin-right: 10px;
}

::v-deep .question-box {
  display: none;
}

::v-deep .question-line {
  padding-left: 0px;
}

::v-deep .question-line p {
  padding-left: 0px !important;
}

::v-deep .item-pane {
  padding-left: -40px !important;
  box-shadow: none;
  -webkit-box-shadow: none;
  background: transparent;
}

.custom-section-title {
  margin-right: 12px;
  font-weight: bold;
}

.checkbox-top-spacing {
  margin-top: 25px;
}

.error-custom {
  margin-top: -28px !important;
  margin-left: 10px !important;
}
.label-design {
  font-size: 14px;
  color: #727272;
}
.container-label {
  margin-bottom: 5px;
}
input.form-control {
  margin-left: 14px;
}
@media screen and (max-width: 768px) {
  ::v-deep .custom-wizard-question {
    .question-box {
      display: none !important;
    }
    .question-box-content {
      display: unset !important;
      .custom-radio-container {
        margin-left: 40px !important;
      }
    }
  }
}

::v-deep .custom-wizard-question {
  .question-box-content {
    .custom-radio-container {
      margin-right: -8px !important;
    }
  }
}

::v-deep .custom-input-read {
  .position-relative {
    position: relative !important;
    right: 0 !important;
  }
}
::v-deep .custom-input-edit {
  .position-relative {
    position: relative !important;
  }
}
</style>
